import React, { FC, useState } from 'react';

import { Image, theme } from 'antd';
import styled from 'styled-components';

import { GeneratedWorkspaceLogo } from '@app/components/WorkspaceLogo';

import { SandboxStatus } from '../SandboxStatus';

const LogoButton = styled.button<{ $focusColor: string }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
  min-height: 35px;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  border-radius: 8px;

  &:focus-visible {
    outline: 2px solid ${({ $focusColor }) => $focusColor};
    outline-offset: 4px;
  }

  .ant-image {
    max-width: 100%;
  }

  .ant-image-img {
    max-width: 100%;
    object-fit: contain;
  }
`;

interface WorkspaceLogoProps {
  title: string;
  src?: string;
  collapsed: boolean;
  onClick: () => void;
}

export const WorkspaceLogo: FC<WorkspaceLogoProps> = ({ title, src, collapsed, onClick }) => {
  const { token } = theme.useToken();
  const [failedSrc, setFailedSrc] = useState<string>();
  const name = title.trim();

  return (
    <div style={{ position: 'relative', width: collapsed ? 32 : '100%', margin: '20px 0' }}>
      <LogoButton type="button" onClick={onClick} title={name} aria-label={name} $focusColor={token.colorPrimary}>
        {src && src !== failedSrc ? (
          <Image
            key={src}
            src={src}
            alt={name}
            height={35}
            preview={false}
            onError={() => setFailedSrc(src)}
            style={{ width: 'auto' }}
          />
        ) : (
          <GeneratedWorkspaceLogo title={name} collapsed={collapsed} />
        )}
      </LogoButton>
      <SandboxStatus />
    </div>
  );
};
